import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgBusiness(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { clipPath: "url(#clip0_19491_1007)" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 4.49976C7.5 2.01447 9.51472 -0.000244141 12 -0.000244141C14.4853 -0.000244141 16.5 2.01447 16.5 4.49976V4.9998H20C21.1046 4.9998 22 5.89523 22 6.9998V10.1343C18.8547 11.5675 15.4726 12.443 12 12.443C8.52657 12.443 5.14627 11.5663 2 10.1343V6.9998C2 5.89523 2.89543 4.9998 4 4.9998H7.5V4.49976ZM14.5 4.49976V4.9998H9.5V4.49976C9.5 3.11904 10.6193 1.99976 12 1.99976C13.3807 1.99976 14.5 3.11904 14.5 4.49976Z", fill: "currentColor" }),
            React.createElement("path", { d: "M2 12.1603V18.9998C2 20.1044 2.89543 20.9998 4 20.9998H20C21.1046 20.9998 22 20.1044 22 18.9998V12.1605C18.8574 13.5295 15.4314 14.293 12 14.293C8.56821 14.293 5.14294 13.5292 2 12.1603Z", fill: "currentColor" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_19491_1007" },
                React.createElement("rect", { width: 24, height: 24, fill: "white" })))));
}
export default SvgBusiness;
